(function Module() {
	'use strict';

	module.exports = {
		usa: {weight: 'lb'},
		aus: {weight: 'kg'},
		international: {weight: 'kg'}
	};
})();
